import React from 'react';

import styles from './WrappableRow.scss';

type RowProps = {
  children: React.ReactNode;
  spacing?: number;
  wrappable?: boolean;
};

function Row(props: RowProps) {
  const { children, spacing = 0 } = props;

  return (
    <div className={styles.row} style={{ gap: `${spacing}px` }}>
      {React.Children.map(children, (child, index) => {
        return <div key={index}>{child}</div>;
      })}
    </div>
  );
}

export default React.memo(Row);
